module.exports = __webpack_public_path__ + "img/LOG.1117bb85.svg";